export default window.env;
